module.exports = __webpack_public_path__ + "img/1f631.ab8ac77.svg";